import React from 'react';
import LocaleAndThemeProvider from 'src/providers/LocaleAndThemeProvider/LocaleAndThemeProvider.tsx';
import r2wc from '@r2wc/react-to-web-component';
import BookTripToolbar from 'src/components/BookTrip/BookTripToolbar';
import QueryProvider from 'src/providers/QueryProvider';
import { BookTripProps } from 'src/components/BookTrip/BookTrip';
import { FeatureFlagsProvider } from 'src/providers/FeatureFlagsProvider/FeatureFlagsProvider';
import { BrowserRouter } from 'react-router-dom';

export const BookTripWrapper: React.FC<BookTripProps> = (props) => {
  return (
    <BrowserRouter>
      <FeatureFlagsProvider>
        <QueryProvider>
          <LocaleAndThemeProvider useShadowDom>
            <BookTripToolbar {...props}></BookTripToolbar>
          </LocaleAndThemeProvider>
        </QueryProvider>
      </FeatureFlagsProvider>
    </BrowserRouter>
  );
};

export const BookTripToolbarComponent = r2wc(BookTripWrapper, {
  props: {
    title: 'string',
    code: 'string',
    days: 'number',
    priceOverrides: 'json',
    bookingSystemOverride: 'boolean',
    bookingLinkOverride: 'json',
  },
  shadow: 'open',
});
export default BookTripToolbarComponent;
